<template>
  <div>
    <v-card-text>
      <CreateUserModal />
      <!--<v-btn dark color="primary" link to="/manage/users/import" disabled>
        <v-icon class="mr-2">mdi-file-import</v-icon>
        TODO: Importuj
      </v-btn>-->
    </v-card-text>
    <v-list>
      <div v-show="loading">
        <v-skeleton-loader v-for="item in take" :key="item" class="mx-auto" type="list-item-two-line" />
      </div>
      <div v-show="!loading">
        <div v-for="user in users" :key="user.id">
          <UsersListElement :user="user" />
          <v-divider inset></v-divider>
        </div>
      </div>
    </v-list>
    <v-card-text>
      <v-pagination
        v-if="pagesLength > 1"
        :value="page"
        :length="pagesLength"
        :total-visible="visiblePages"
        :disabled="loading"
        circle
        @input="pageChanged"
      ></v-pagination>
    </v-card-text>
  </div>
</template>

<script>
import UsersListElement from '@/components/manage/users/UsersListElement.vue';
import CreateUserModal from '@/components/manage/users/manage-user/CreateUserModal.vue';

export default {
  components: {
    UsersListElement,
    CreateUserModal
  },
  props: {
    users: {
      type: Array,
      required: true
    },
    pagesLength: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    take: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    visiblePages: {
      type: Number,
      default: 7
    }
  },
  methods: {
    pageChanged(page) {
      this.$emit('pageChanged', { page: page });
    }
  }
};
</script>
